import { fromJS, Map } from "immutable";
import {
  LOAD_CONFIG_OPTIONS,
  EDIT_CONFIG_OPTION,
  ANGULAR_INIT,
  SET_PASSWORD_SUCCESS,
  COMPLETE_BILLING_ORDER_SUCCESS,
  FETCH_CONFIG_OPTIONS_SUCCESS,
  SET_CONFIG_OPTION,
  EDIT_CONFIG_OPTIONS_SUCCESS,
  SETUP_WIZARD_FEATURES_SHOWN,
  EDIT_USERS_WORKWEEK_CAPACITIES_SUCCESS,
  EDIT_CLIENT_PLUS_SUCCESS,
} from "~/store/action_types";

const on_demand_settings = (state = Map(), action) => {
  switch (action.type) {
    case COMPLETE_BILLING_ORDER_SUCCESS: {
      if (action.response.is_paid) {
        return state.set(`account_status`, `active`);
      }
      return state;
    }
    default:
      return state;
  }
};

const config_options = (state = Map(), action) => {
  switch (action.type) {
    case LOAD_CONFIG_OPTIONS:
      return fromJS(action.response);
    case ANGULAR_INIT:
      return fromJS(action.response.config_options);
    case EDIT_CONFIG_OPTION:
    case EDIT_CONFIG_OPTIONS_SUCCESS:
    case FETCH_CONFIG_OPTIONS_SUCCESS:
      return state.merge(fromJS(action.response));
    case SET_PASSWORD_SUCCESS: {
      return action.response && action.response.is_ok ? state.set(`show_set_password`, false) : state;
    }
    case SETUP_WIZARD_FEATURES_SHOWN: {
      return state.set(`show_features_info`, false);
    }
    case EDIT_CLIENT_PLUS_SUCCESS: {
      return state.set(`client_plus_enabled`, action.client_plus_enabled);
    }
    case COMPLETE_BILLING_ORDER_SUCCESS:
      return state.set(`on_demand_settings`, on_demand_settings(state.get(`on_demand_settings`), action));
    case SET_CONFIG_OPTION: {
      const { name, value } = action;
      return state.set(`${name}`, fromJS(value));
    }
    case EDIT_USERS_WORKWEEK_CAPACITIES_SUCCESS: {
      const { response = {} } = action;
      const { time_workdays = [], weekly_worker_capacity = [] } = response;

      return state
        .set(`time_workdays`, fromJS(time_workdays))
        .set(`weekly_worker_capacity`, fromJS(weekly_worker_capacity));
    }
    default:
      return state;
  }
};

export default config_options;

export const getAvatarUrl = (state, userId = 0, size = ``, updatedOn = 0) => {
  let sizeInPixels = 40;

  if (size === `photo`) {
    sizeInPixels = 256;
  } else if (size === `small`) {
    sizeInPixels = 16;
  } else if (size === `large`) {
    sizeInPixels = 80;
  }

  return state
    .get(`avatar_url`, ``)
    .replace(`--USER-ID--`, userId)
    .replace(`--SIZE--`, sizeInPixels)
    .replace(`--UPDATED-ON--`, updatedOn);
};
